var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDocumentSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.8 4.8a2.4 2.4 0 012.4-2.4h5.503a2.4 2.4 0 011.697.703L18.497 7.2a2.4 2.4 0 01.703 1.697V19.2a2.4 2.4 0 01-2.4 2.4h-1.833A7.2 7.2 0 004.8 11.433V4.8z",
    fill: "gray"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.6 12a4.8 4.8 0 00-4.135 7.238L3.95 20.752a1.2 1.2 0 101.698 1.697l1.513-1.514A4.8 4.8 0 109.6 12zm-2.4 4.8a2.4 2.4 0 114.8 0 2.4 2.4 0 01-4.8 0z",
    fill: "gray"
  })));
}

export default SvgDocumentSearch;